<template>
  <div class="header">
    <div class="logout_btn text_size_16 margin-right-10" @click="handleClose">
      <i class="iconfont icongeren1 text_size_32" style="color:#D9DBDF;"></i>
    </div>
  </div>
</template>
<script>
import { removeToken } from '../../../../config/token'
export default {
  name: 'layoutContainerHeader',
  methods: {
    // 注销账号
    logout () {
      removeToken()
      localStorage.removeItem('userInfo')
      this.$router.push('/login')
    },
    handleClose () {
      this.$confirm('确认退出？', '确认提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.logout()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    }
  }

}
</script>
<style lang="scss" scoped>
  .header {
    flex: none;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    min-height:60px;
    padding-right: 40px;
    background-color: #ffffff;
    box-shadow:0px 0px 10px rgba(53,53,53,0.15);
    z-index: 100;
    .logout_btn {
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/container/header/index.vue